export default "__VITE_ASSET__Co2$xl4f__"